export interface Country {
    id?: number;
    name?: string;
    code?: string | null;
    is_active?: boolean;
}

export interface CountryDataForm {
    id?: number;
    name?: string;
    code?: string | null;
    is_active?: boolean;
}

export interface CountryFilters {
    id?: number | null;
    name?: string | '';
    code?: string | '';
    page: number;
    per_page: number;
    sort: string;
    order: string;
}

export const defaultCountryDataForm: CountryDataForm = {
    name: '',
    code: '',
    is_active: true
};
